<template lang="pug">

    div.field(v-bind:class='classes')


        label(v-if='field.type !== "MULTIPLE"') {{ field.name }}
            i.question.circle.icon(v-tooltip="field.hint" v-if="field.hint")

        component(
            ref='implField'
            v-bind:is='component'
            v-bind:field='field'
            v-bind:field-models='childFieldModels'
            v-model='model'
        )


</template>

<script>
    import CheckboxField from './field/CheckboxField'
    import ColorField from './field/ColorField'
    import DropdownField from './field/DropdownField'
    import MultipleField from './field/MultipleField'
    import NumberField from './field/NumberField'
    import RadioField from './field/RadioField'
    import StringField from './field/StringField'
    import TextField from './field/TextField'
    import UnknownField from './field/UnknownField'
    import * as R from "ramda";

    //noinspection JSUnusedGlobalSymbols,ReservedWordAsName
    export default {

        components: {
            CheckboxField, ColorField, DropdownField, MultipleField, NumberField, RadioField, StringField, TextField, UnknownField
        },

        computed: {

            $invalid() {
                return this.$refs.implField.$invalid
            },

            classes() {
                return {
                    required: this.field.required
                }
            },

            childFieldModels() {
                return R.compose(

                    // Alle Felder holen, die den ID-Präfix die eigene id + `-`
                    // [ { id: "form-1-1" }, { id: "form-1-2" }, { id: "form-1-2-1" }, { id: "form-1-2-1-1" } ]
                    // => [ { id: "form-1-2-1" }, { id: "form-1-2-1-1" } ]
                    R.filter(field => R.startsWith(`${this.field.id}-`, field.id))

                )(this.fieldModels)
            },

            component() {
                switch (this.field.type) {
                    case 'CHECKBOX': return 'checkbox-field'
                    case 'COLOR': return 'color-field'
                    case 'DROPDOWN': return 'dropdown-field'
                    case 'MULTIPLE': return 'multiple-field'
                    case 'NUMBER': return 'number-field'
                    case 'RADIO': return 'radio-field'
                    case 'STRING': return 'string-field'
                    case 'TEXT': return 'text-field'
                    default: return 'unknown-field'
                }
            },

            model: {
                get() { return this.value },
                set(value) { this.$emit('input', value) }
            }

        },

        methods: {

            $touch() {
                if (this.field.type === 'DROPDOWN') {
                    this.$refs.implField.$touch()
                }
            }

        },

        props: {

            field: {
                type: Object,
                required: true
            },

            forceVisibility: {
                type: Boolean,
                default: false,
            },

            fieldModels: {
                type: Array,
                required: true
            },

            value: {
                required: true
            }

        }

    }

</script>

<style scoped>
    i.icon {
        margin: 0 0.25rem 0 0.25rem;
    }
</style>
